import React from "react";

import { SvgIconProps, SvgIcon } from "@mui/material";

const DownloadReportIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 13 12" {...props}>
      <path
        d="M10.0781 4.75H8.07812V1.75H5.07812V4.75H3.07812L6.57812 8.25L10.0781 4.75ZM6.07812 5.75V2.75H7.07812V5.75H7.66313L6.57812 6.835L5.49312 5.75H6.07812ZM3.07812 9.25H10.0781V10.25H3.07812V9.25Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default DownloadReportIcon;
